import { TranslationsApi } from '../types/api/translations-api';
import { BaseRouteProps } from '../types/route-props';
import { buildURL, isV3 } from '../common';
import { Method, callAxios } from '../axios';
import { getBrandName } from '../locale';

const getTranslationURL = (contextRoot: string, languageCode: string, countryCode: string) => {
  const brand = getBrandName();
  if (process.env.REACT_APP_DEV === 'mock') return 'http://localhost:3100/get-translations';
  if (isV3()) {
    return buildURL({
      host: process.env.API_HOST,
      endpoint: `/products-comparison/main?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
    });
  }

  return buildURL({
    host: process.env.API_HOST,
    contextRoot,
    countryCode,
    languageCode,
    endpoint: '/product/api/products/comparison/main',
  });
};

export const translationsApiFetchers = {
  getTranslationsFetcher: async ({
    contextRoot,
    countryCode,
    languageCode,
    params = { content: 'labels' },
  }: BaseRouteProps & {
    params?: TranslationsApi.GetTranslationsParams;
  }) => {
    const GET_TRANSLATIONS_URL = getTranslationURL(contextRoot, languageCode, countryCode);
    const response = await callAxios<{
      response: TranslationsApi.GetTranslationsResponce;
      params: typeof params;
    }>({
      method: Method.GET,
      url: GET_TRANSLATIONS_URL,
      params,
    });

    return response.data;
  },
};
